import React from 'react';
import './styles.scss';

interface SourceProps {
  source: string;
  url: string;
}

const Source: React.FC<SourceProps> = ({ source, url }) => {
  return (
    <div className="source-widget">
      <span>Source: </span>
      <a href={url} target="_blank" rel="noopener noreferrer">
        {' '}
        {source}
      </a>
    </div>
  );
};

export default Source;
